module.exports = __webpack_public_path__ + "static/media/vector.cf87b1c3.svg";